import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/utils/auth';
Vue.use(Router)



/* Layout */
// import Layout from '@/layout'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
const constantRoutes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/question/district'),
    meta: { requiresAuth: true },
    hidden: true
  },
  // {
  //   path: '/district',
  //   name: 'index',
  //   component: () => import('@/views/question/district'),
  //   meta: { requiresAuth: true },
  //   hidden: true
  // },
  {
    path: '/addModule',
    name: 'addModule',
    component: () => import('@/views/AddModule'),
    meta: { requiresAuth: true },
    hidden: true
  },
  {
    path: '/special',
    name: 'special',
    component: () => import('@/views/special/specialIndex'),
    meta: { requiresAuth: true },
    hidden: true
  },
  {
    path: '/special/detail',
    name: 'specialDetail',
    component: () => import('@/views/special'),
    meta: { requiresAuth: true },
    hidden: true
  },
  {
    path: '/logs',
    name: 'logs',
    component: () => import('@/components/testContent/dialog/operationLog'),
    meta: { requiresAuth: true },
    hidden: true
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login'),
    hidden: true
  },
  // {
  //   path: '/user',
  //   component: Layout,
  //   hidden: true,
  //   redirect: 'noredirect',
  //   children: [
  //     {
  //       path: 'profile',
  //       component: () => import('@/views/system/user/profile/index'),
  //       name: 'Profile',
  //       meta: { title: '个人中心', icon: 'user' }
  //     }
  //   ]
  // }
]


const router = new Router({
  routes: constantRoutes
})

router.beforeEach((to, from, next) => {

  console.log('router.beforeEach')
  console.log(getToken())
  if(getToken()){
    if(to.path === '/login'){
      next({ path: '/' })
    }
  }
  // 判断需要登录的页面，如果用户未登录，则跳转到登录页
  if (to.meta.requiresAuth && !getToken()) {
    
    next('/login'); // 假设登录页的路径是 /login
  } else {
    next(); // 继续正常的路由
  }

});

export default router;